/** Quick-jump keys for User builder — one visible panel at a time. */
export const USER_BUILDER_SECTIONS = [
  {
    key: "users-create",
    label: "Create user",
    group: "Users",
    targetId: "ub-users-create",
    description: "Add staff accounts with role and status.",
  },
  {
    key: "users-directory",
    label: "User directory",
    group: "Users",
    targetId: "ub-users-directory",
    description: "Search, filter, and manage existing users.",
  },
  {
    key: "roles-create",
    label: "Create role",
    group: "Roles",
    targetId: "ub-roles-create",
    description: "Define a new role slug for permissions.",
  },
  {
    key: "roles-directory",
    label: "Role directory",
    group: "Roles",
    targetId: "ub-roles-directory",
    description: "Browse and soft-delete active roles.",
  },
  {
    key: "perm-modules",
    label: "Menu modules",
    group: "Access",
    targetId: "ub-module-permissions",
    description: "Top-level module access for a role.",
  },
  {
    key: "perm-submodules",
    label: "Screens",
    group: "Access",
    targetId: "ub-submodule-permissions",
    description: "Per-screen permissions and sidebar links.",
  },
];

export const DEFAULT_USER_BUILDER_SECTION = USER_BUILDER_SECTIONS[0].key;
